import { render, staticRenderFns } from "./sendQuotation.vue?vue&type=template&id=601d7b87"
import script from "./sendQuotation.vue?vue&type=script&lang=js"
export * from "./sendQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports